export class EditWatchlistUI {
    constructor(containerEl, handlers) {
        this.el = containerEl;
        this.handlers = handlers || {};
        
        this.popupBgDark = this.el.querySelector('.background-panel-dark');
        this.popupBgLight = this.el.querySelector('.background-panel-light');
    }

    applyTheme(isLight) {
        if (this.popupBgDark) this.popupBgDark.setAttribute('visible', !isLight);
        if (this.popupBgLight) this.popupBgLight.setAttribute('visible', isLight);
    }

    render(options) {
        const {
            isLoading,
            isTrueEmptyState,
            watchlists,
            currentWatchlistId,
            currentWatchlistData,
            selectedTickers,
            currentPage,
            rowsPerPage
        } = options;

        this.el.innerHTML = ''; 
        
        const settings = (typeof getCacheItem === 'function') ? getCacheItem('mainSettings') : null;
        const isLight = settings && settings.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';
        const panelColor = isLight ? '#F5F5F5' : '#111';

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('width', 2.2);
        bg.setAttribute('height', 1.09);
        bg.setAttribute('position', '-1.1 -0.490 -0.05'); 
        bg.setAttribute('color', panelColor);
        bg.setAttribute('radius', 0.02);
        this.el.appendChild(bg);

        const header = document.createElement('a-entity');
        header.setAttribute('position', '0 0.52 0.02');
        this.el.appendChild(header);

        const title = document.createElement('a-troika-text');
        title.setAttribute('value', 'Edit Watchlist');
        title.setAttribute('font-size', 0.05);
        title.setAttribute('color', txtColor);
        title.setAttribute('anchor', 'center');
        header.appendChild(title);

        const currentWl = watchlists ? watchlists.find(w => w.id === currentWatchlistId) : null;
        const wlName = currentWl ? currentWl.name : 'Select Watchlist';
        const wlDisplayName = wlName.length > 10 ? `${wlName.slice(0, 10)}...` : wlName;

        if (!isTrueEmptyState) {
            const nameGroup = document.createElement('a-entity');
            nameGroup.setAttribute('position', '-1.0 0 0');
            header.appendChild(nameGroup);
            const selectBtn = document.createElement('a-entity');
            selectBtn.setAttribute('ui-button', {
                label: wlDisplayName,
                width: 0.45,
                height: 0.07,
                colorScheme: 'primary',
                type: 'rounded-box',
                depth: 0.02,
                radius: 0.015,
                preferredFontSize: 0.035,
                align: 'left'
            });
            selectBtn.setAttribute('position', '0.175 0 0'); 
            
            setTimeout(() => {
                selectBtn.removeAttribute('data-raycastable');
                selectBtn.classList.remove('clickable');
            }, 50);

            nameGroup.appendChild(selectBtn);

            const plusBtn = document.createElement('a-entity');
            plusBtn.setAttribute('ui-button', {
                label: '+',
                width: 0.07,
                height: 0.07,
                colorScheme: 'primary',
                type: 'rounded-box',
                depth: 0.02,
                radius: 0.015,
                preferredFontSize: 0.035
            });
            plusBtn.setAttribute('position', '0.480 0 0');
            plusBtn.addEventListener('click', () => { if (this.handlers.onAddWatchlist) this.handlers.onAddWatchlist(); });
            nameGroup.appendChild(plusBtn);

            const minusBtn = document.createElement('a-entity');
            minusBtn.setAttribute('ui-button', {
                image: 'vr-assets/trash.svg',
                imageWidth: 0.04,
                imageHeight: 0.04,
                width: 0.07,
                height: 0.07,
                colorScheme: 'primary',
                type: 'rounded-box',
                depth: 0.02,
                radius: 0.015
            });
            minusBtn.setAttribute('position', '0.585 0 0'); 
            minusBtn.addEventListener('click', () => { if (this.handlers.onDeleteWatchlist) this.handlers.onDeleteWatchlist(); });
            nameGroup.appendChild(minusBtn);

            const renameBtn = document.createElement('a-entity');
            renameBtn.setAttribute('ui-button', {
                label: 'Rename',
                width: 0.18,
                height: 0.080,
                colorScheme: 'primary',
                type: 'rounded-box',
                depth: 0.02,
                radius: 0.015,
                preferredFontSize: 0.035
            });
            renameBtn.setAttribute('position', '0.720 0 0');
            renameBtn.addEventListener('click', () => { if (this.handlers.onRenameWatchlist) this.handlers.onRenameWatchlist(); });
            nameGroup.appendChild(renameBtn);

            const count = currentWatchlistData ? currentWatchlistData.length : 0;
            const counter = document.createElement('a-troika-text');
            counter.setAttribute('value', `${count} / 50`);
            counter.setAttribute('font-size', 0.035);
            counter.setAttribute('color', '#888');
            counter.setAttribute('anchor', 'left');
            counter.setAttribute('position', '0.22 0 0'); 
            header.appendChild(counter);

            const csvBtn = document.createElement('a-entity');
            csvBtn.setAttribute('ui-button', {
                label: 'Upload CSV',
                width: 0.35,
                height: 0.08,
                colorScheme: 'primary',
                type: 'image-text',
                depth: 0.02,
                radius: 0.015,
                preferredFontSize: 0.035,
                image: 'vr-assets/upload.svg', 
                imageWidth: 0.03,
                imageHeight: 0.03,
                gap: 0.07
            });
            csvBtn.setAttribute('position', '0.7 0 0'); 
            csvBtn.addEventListener('click', () => { if (this.handlers.onImportCsv) this.handlers.onImportCsv(); });
            header.appendChild(csvBtn);

            const csvTooltip = document.createElement('a-entity');
            csvTooltip.setAttribute('visible', false);
            csvTooltip.setAttribute('position', '0.7 -0.2 0.05'); 
            header.appendChild(csvTooltip);

            const tooltipBg = document.createElement('a-rounded-plane');
            const ttWidth = 1.64;
            const ttHeight = 0.28;
            tooltipBg.setAttribute('width', ttWidth);
            tooltipBg.setAttribute('height', ttHeight);
            tooltipBg.setAttribute('color', panelColor);
            tooltipBg.setAttribute('radius', 0.02);
            tooltipBg.setAttribute('position', `${-ttWidth/2} ${-ttHeight/2} -0.01`);
            csvTooltip.appendChild(tooltipBg);

            const tooltipText = document.createElement('a-troika-text');
            tooltipText.setAttribute('value', 
                '1) Go to your brokerage web site\n' +
                '2) Export a .CSV file containing your stock positions and save it locally on your computer\n' +
                '3) Import that .CSV file into StockStorm to load your stock symbols, number of shares, and cost basis'
            );
            tooltipText.setAttribute('font-size', 0.032);
            tooltipText.setAttribute('color', txtColor);
            tooltipText.setAttribute('anchor', 'center');
            tooltipText.setAttribute('baseline', 'center');
            tooltipText.setAttribute('width', ttWidth - 0.05); 
            tooltipText.setAttribute('line-height', 1.4);
            tooltipText.setAttribute('position', '0 0 0');
            csvTooltip.appendChild(tooltipText);

            csvBtn.addEventListener('mouseenter', () => { csvTooltip.setAttribute('visible', true); });
            csvBtn.addEventListener('mouseleave', () => { csvTooltip.setAttribute('visible', false); });
        }

        const cross = document.createElement('a-troika-text');
        cross.setAttribute('value', '×');
        cross.setAttribute('font-size', 0.07);
        cross.setAttribute('color', txtColor);
        cross.setAttribute('position', '1.05 0.02 0');
        cross.setAttribute('anchor', 'center');
        header.appendChild(cross);

        const closePlane = document.createElement('a-plane');
        closePlane.setAttribute('width', 0.1);
        closePlane.setAttribute('height', 0.1);
        closePlane.setAttribute('position', '1.05 0 0.01');
        closePlane.setAttribute('opacity', 0);
        closePlane.setAttribute('data-raycastable', '');
        closePlane.addEventListener('click', () => { if (this.handlers.onCancel) this.handlers.onCancel(); });
        header.appendChild(closePlane);

        const content = document.createElement('a-entity');
        content.setAttribute('position', '0 0 0.02');
        this.el.appendChild(content);

        if (isLoading) {
            const loading = document.createElement('a-troika-text');
            loading.setAttribute('value', 'Loading...');
            loading.setAttribute('font-size', 0.05);
            loading.setAttribute('color', txtColor);
            loading.setAttribute('anchor', 'center');
            loading.setAttribute('position', '0 0 0');
            content.appendChild(loading);
            return;
        }

        if (isTrueEmptyState) {
            const createBtn = document.createElement('a-entity');
            createBtn.setAttribute('ui-button', {
                label: 'Create a watchlist',
                width: 0.5,
                height: 0.1,
                colorScheme: 'primary',
                type: 'rounded-box',
                depth: 0.02,
                radius: 0.02,
                preferredFontSize: 0.04
            });
            createBtn.setAttribute('position', '0 0.1 0');
            createBtn.setAttribute('data-raycastable', '');
            createBtn.addEventListener('click', () => { if (this.handlers.onAddWatchlist) this.handlers.onAddWatchlist(); });
            content.appendChild(createBtn);
            return;
        }

        const tableContainer = document.createElement('a-entity');
        const tableScale = 4.4; 
        tableContainer.setAttribute('scale', `${tableScale} ${tableScale} 1`);
        tableContainer.setAttribute('position', '0 0.41 0');
        content.appendChild(tableContainer);

        const headerArr = ['', 'Symbol', '# of Shares', 'Cost Basis', ''];
        const allData = currentWatchlistData || [];
        
        const sortedData = [...allData].sort((a, b) => {
            const tickerA = (a.ticker || '').toUpperCase();
            const tickerB = (b.ticker || '').toUpperCase();
            if (tickerA < tickerB) return -1;
            if (tickerA > tickerB) return 1;
            return 0;
        });

        const totalPages = Math.max(1, Math.ceil(sortedData.length / rowsPerPage));
        const safePage = Math.min(currentPage, Math.max(0, totalPages - 1));

        const start = safePage * rowsPerPage;
        const pageData = sortedData.slice(start, start + rowsPerPage);

        const rows = pageData.map(stock => {
            const holding = (currentWl && currentWl.holdings ? currentWl.holdings[stock.ticker] : {}) || {};
            return [
                selectedTickers.has(stock.ticker), 
                stock.ticker,
                holding.quantity ? String(holding.quantity) : '',
                holding.price ? `$${parseFloat(holding.price).toFixed(2)}` : '',
                stock.ticker 
            ];
        });

        const visibleHeight = 0.154;

        tableContainer.setAttribute('table', {
            width: 0.48,
            rowHeight: 0.014,
            visibleHeight: visibleHeight, 
            headerBgColor: isLight ? '#E0E0E0' : '#222222',
            headerColor: isLight ? '#14141C' : '#ffffff',
            rowColor1: isLight ? '#ffffff' : '#1a1a1a',
            rowColor2: isLight ? '#f5f5f5' : '#151515',
            textColor: isLight ? '#14141C' : '#cccccc',
            equalColumns: false,
            columnWidths: '0.05, 0.25, 0.3, 0.25, 0.15', 
            checkboxColumn: 0,
            buttonColumn: 4,
            buttonLabel: 'Edit',
            data: JSON.stringify([headerArr, ...rows])
        });

        tableContainer.addEventListener('table-checkbox-click', (evt) => {
            if (this.handlers.onCheckboxClick) {
                this.handlers.onCheckboxClick(evt.detail, sortedData);
            }
        });

        tableContainer.addEventListener('table-button-click', (evt) => {
            if (this.handlers.onEditHoldings) this.handlers.onEditHoldings(evt.detail);
        });

        if (totalPages > 1) {
            this._renderPaginationControls(content, totalPages, safePage, isLight);
        }
        const footer = document.createElement('a-entity');
        footer.setAttribute('position', '0 -0.41 0.02');
        this.el.appendChild(footer);

        const addBtn = document.createElement('a-entity');
        addBtn.setAttribute('ui-button', {
            label: 'Add Unit +',
            width: 0.22,
            height: 0.06,
            colorScheme: 'primary',
            type: 'rounded-box',
            depth: 0.02,
            radius: 0.018,
            preferredFontSize: 0.035
        });
        addBtn.setAttribute('position', '-0.9 0 0');
        addBtn.addEventListener('click', () => { if (this.handlers.onAdd) this.handlers.onAdd(); });
        footer.appendChild(addBtn);

        const removeBtn = document.createElement('a-entity');
        removeBtn.setAttribute('ui-button', {
            label: 'Remove Unit -',
            width: 0.260,
            height: 0.06,
            colorScheme: 'primary',
            type: 'rounded-box',
            depth: 0.02,
            radius: 0.018,
            preferredFontSize: 0.035
        });
        removeBtn.setAttribute('position', '-0.55 0 0');
        removeBtn.addEventListener('click', () => { if (this.handlers.onRemove) this.handlers.onRemove(); });
        footer.appendChild(removeBtn);

        const saveBtn = document.createElement('a-entity');
        saveBtn.setAttribute('id', 'edit-wl-save-btn');
        saveBtn.setAttribute('ui-button', {
            label: 'Save',
            width: 0.18,
            height: 0.06,
            colorScheme: 'accent',
            type: 'rounded-box',
            depth: 0.02,
            radius: 0.018,
            preferredFontSize: 0.035
        });
        saveBtn.setAttribute('position', '0.92 0 0');
        saveBtn.addEventListener('click', () => { if (this.handlers.onSave) this.handlers.onSave(); });
        footer.appendChild(saveBtn);

        const cancelBtn = document.createElement('a-entity');
        cancelBtn.setAttribute('ui-button', {
            label: 'Cancel',
            width: 0.18,
            height: 0.06,
            colorScheme: 'primary',
            type: 'rounded-box',
            depth: 0.02,
            radius: 0.018,
            preferredFontSize: 0.035
        });
        cancelBtn.setAttribute('position', '0.65 0 0');
        cancelBtn.addEventListener('click', () => { if (this.handlers.onCancel) this.handlers.onCancel(); });
        footer.appendChild(cancelBtn);
    }

    _renderPaginationControls(parent, totalPages, currentPage, isLight) {
        const container = document.createElement('a-entity');
        container.setAttribute('position', '0 -0.34 0.02');
        parent.appendChild(container);

        const prevBtn = document.createElement('a-entity');
        prevBtn.setAttribute('position', '-0.2 0 0');
        prevBtn.setAttribute('visible', currentPage > 0);
        
        prevBtn.setAttribute('ui-button', {
            label: '<',
            width: 0.1,
            height: 0.06,
            colorScheme: 'primary',
            type: 'rounded-box',
            radius: 0.01,
            depth: 0.02,
            preferredFontSize: 0.035
        });

        prevBtn.addEventListener('click', () => {
            if (currentPage > 0 && this.handlers.onPageChange) {
                this.handlers.onPageChange(currentPage - 1);
            }
        });
        container.appendChild(prevBtn);

        const label = document.createElement('a-troika-text');
        label.setAttribute('value', `${currentPage + 1} / ${totalPages}`);
        label.setAttribute('font-size', 0.04);
        label.setAttribute('color', isLight ? '#14141C' : '#FFF');
        label.setAttribute('anchor', 'center');
        container.appendChild(label);

        const nextBtn = document.createElement('a-entity');
        nextBtn.setAttribute('position', '0.2 0 0');
        nextBtn.setAttribute('visible', currentPage < totalPages - 1);
        
        nextBtn.setAttribute('ui-button', {
            label: '>',
            width: 0.1,
            height: 0.06,
            colorScheme: 'primary',
            type: 'rounded-box',
            radius: 0.01,
            depth: 0.02,
            preferredFontSize: 0.035
        });

        nextBtn.addEventListener('click', () => {
            if (currentPage < totalPages - 1 && this.handlers.onPageChange) {
                this.handlers.onPageChange(currentPage + 1);
            }
        });
        container.appendChild(nextBtn);
    }
}
